<section class="completed-shell">
  <header class="completed-summary" [class.declined-summary]="tone === 'declined'">
    <div>
      <p class="completed-eyebrow">{{ eyebrow }}</p>
      <h1>{{ title }}</h1>
      <p class="completed-copy">{{ copy }}</p>
    </div>

    <dl class="completed-meta">
      @for (item of metaItems; track item.label) {
        <div>
          <dt>{{ item.label }}</dt>
          <dd>{{ item.value }}</dd>
        </div>
      }
    </dl>
  </header>

  <div class="completed-layout">
    <section class="viewer-stage completed-viewer" #viewerHost>
      <div class="viewer-wrap">
        @if (pdfUrl) {
          <ngx-extended-pdf-viewer
            [src]="pdfUrl"
            [disableForms]="true"
            [textLayer]="false"
            [showFindButton]="false"
            [showPagingButtons]="false"
            [showPreviousAndNextPageButtons]="false"
            [showFirstAndLastPageButtons]="false"
            [showPageNumber]="false"
            [showZoomButtons]="false"
            [showZoomDropdown]="false"
            [showSidebarButton]="false"
            [showSecondaryToolbarButton]="false"
            [showPresentationModeButton]="false"
            [showOpenFileButton]="false"
            [showPrintButton]="false"
            [showDownloadButton]="false"
            [showPropertiesButton]="false"
            [showRotateButton]="false"
            [showHandToolButton]="false"
            [showEditorButtons]="false"
            [showPageFlipButton]="false"
            [showSpreadButton]="false"
            [rotation]="viewerRotation"
            [zoom]="zoomLevel"
            [page]="viewerPage"
            [height]="'calc(100vh - 14rem)'"
            (pagesLoaded)="onPagesLoaded($event)"
            (pageChange)="onPageChange($event)"
            (pageRendered)="onPageRendered()"
            (rotationChange)="onViewerRotationChange($event)"
          ></ngx-extended-pdf-viewer>
        } @else {
          <p class="empty">{{ emptyText }}</p>
        }
      </div>
    </section>
  </div>
</section>
